import { getEventTransfer } from "@convertkit/slate-react"
import Plain from "@convertkit/slate-plain-serializer"
import { detectMarkdown, markdownToHTML } from "../utils/markdown-api"
import { confirm } from "@kit/design/modal"
import { parse } from "@convertkit/editor"
import { log } from "utils/log"

export const detectLiquid = string =>
  string.includes("{%") || string.includes("{{")

export const getCurrentLine = editor => editor?.value?.startBlock?.text

const getPastedText = event => getEventTransfer(event).text

const confirmUserChoice = async () =>
  await confirm("Format as Markdown?", {
    message:
      "It looks like you're using Markdown. Would you like us to auto-format your paste?",
    confirm: "Yes, format",
    cancel: "No, paste as usual"
  })

const sendLog = (editor, shouldFormat) =>
  log("markdown", {
    location: editor.props.location,
    url: window.location.href,
    choseToFormat: shouldFormat
  })

const deserializeText = (text, editor) => {
  const { document, selection, startBlock } = editor.value
  const defaultMarks = document.getInsertMarksAtRange(selection)
  return Plain.deserialize(text, { defaultBlock: startBlock, defaultMarks })
    .document
}

const isInvalidPaste = (text, editor) => {
  const startBlock = editor?.value?.startBlock
  return !text || editor.isVoid(startBlock)
}

export const insertFormattedMarkdown = (formattedMarkdown, editor) => {
  const { document } = parse(formattedMarkdown)
  editor.insertFragment(document)
}

export const insertUnformattedText = (eventTransfer, editor) => {
  const { type, fragment, text, html } = eventTransfer

  if (type === "fragment") {
    editor.insertFragment(fragment)
  } else if (type === "html") {
    const { document } = parse(html, { fontSize: false })
    editor.insertFragment(document)
  } else if (type === "text") {
    if (isInvalidPaste(text, editor)) return
    const deserialized = deserializeText(text, editor)
    editor.insertFragment(deserialized)
  }
}

const handleMarkdownPaste = async (event, editor) => {
  const eventTransfer = getEventTransfer(event)

  const formattedMarkdown = await markdownToHTML(eventTransfer.text)
  const choseToFormat = await confirmUserChoice()
  sendLog(editor, choseToFormat)

  if (choseToFormat) insertFormattedMarkdown(formattedMarkdown, editor)
  else insertUnformattedText(eventTransfer, editor)
}

const onPaste = async (event, editor, next) => {
  const currentLine = getCurrentLine(editor)
  const pastedText = getPastedText(event)

  if (detectLiquid(currentLine)) next()
  else if (detectMarkdown(pastedText)) handleMarkdownPaste(event, editor)
  else next()
}

export function formatPastes() {
  if (process.env.NODE_ENV === "test") return {}
  return { onPaste }
}
